import React from 'react';
import PropTypes from 'prop-types';
import styles from './AreaSelector.scss';

const AreaSelector = ({ items, currentArea, changeAreaAndRegion }) => (
  <div className={styles.selector}>
    {
      items.map(({ id, title }) =>
        <button
          key={id}
          className={currentArea === id ? styles.selected : styles.button}
          type="button"
          onClick={() => changeAreaAndRegion(id)}
        >
          {title}
        </button>,
      )
    }
  </div>
);

AreaSelector.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  currentArea: PropTypes.string.isRequired,
  changeAreaAndRegion: PropTypes.func.isRequired,
};

export default AreaSelector;
